import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import AdminQuillEditor from '@/global-components/AdminQuillEditor.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(AdminQuillEditor.name, AdminQuillEditor)
